import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { Header } from "../../Header";
import { RenderBesides } from "./RenderBesides";
import { Footer } from "./Footer";
export default function Layout(param) {
    let { children  } = param;
    return /*#__PURE__*/ _jsx("div", {
        className: "bg-background-basic min-h-screen flex",
        children: /*#__PURE__*/ _jsxs("div", {
            className: "flex flex-col w-full",
            children: [
                /*#__PURE__*/ _jsx(RenderBesides, {
                    routes: [
                        "/explore-parks/[[...slug]]"
                    ],
                    children: /*#__PURE__*/ _jsx("div", {
                        className: "sticky top-0 z-[90] flex-shrink-0 flex h-16 p-4 h-[84px] bg-white shadow",
                        children: /*#__PURE__*/ _jsx(Header, {})
                    })
                }),
                /*#__PURE__*/ _jsx("main", {
                    className: "flex flex-1 p-0",
                    children: /*#__PURE__*/ _jsx("div", {
                        className: "mx-auto w-full flex flex-1 flex-col",
                        children: children
                    })
                }),
                /*#__PURE__*/ _jsx(RenderBesides, {
                    routes: [
                        "/explore-parks/[[...slug]]"
                    ],
                    children: /*#__PURE__*/ _jsx(Footer, {})
                })
            ]
        })
    });
}
